<!--
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2024-03-25 23:42:34
-->
<template>
    <div class="works">
        <div v-if="banner && banner.length" class="works-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)">
        </div>
        <div class="works-body">
            <div class="works-tabs">
                <Tabs :tabsList="tabsList" :activeType="activeType" @handleTab="handleTab" />
            </div>
            <works-list :type="activeType"></works-list>
        </div>
    </div>
</template>

<script>
import { getWorkTabs } from '@/api/works';
import { getBannerURL } from '@/api/common';
import WorksList from './components/WorksList';
import Tabs from '@/components/Tabs';

export default {
    name: 'Works',
    components: {
        WorksList,
        Tabs
    },
    data: () => ({
        tabsList: [
            {
                type: 'all',
                title: '全部作品'
            }
        ],
        activeType: sessionStorage.getItem('workTab') || 'all',
        banner: null
    }),
    mounted() {
        this.getTabs();
        this.getBannerURL()
    },
    methods: {
        openBanner(imgUrl) {
            window.open(imgUrl);
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(2).then(({ data }) => {
                this.banner = (data || []).splice(0,2);
            });
        },
        getTabs() {
            getWorkTabs({
                type: 1
            }).then(({ code, data }) => {
                if (code === 0) {
                    const tabsList = data.map(({ id, name }) => {
                        return {
                            type: id,
                            title: name
                        };
                    });
                    this.tabsList = [
                        {
                            type: 'all',
                            title: '全部作品'
                        },
                        ...tabsList
                    ];
                }
            });
        },
        handleTab(type) {
            sessionStorage.setItem('workTab', type)
            sessionStorage.setItem(this.$route.path, 1)
            this.activeType = type;
        }
    }
};
</script>

<style lang="scss" scoped>
.works {
    &-tabs {
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(224, 228, 247, 1);
    }
    &-banner {
		text-align: center;
		font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
		> img {
			cursor: pointer;
			flex: 1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
			font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
		}
	}
    &-body {
        margin: 0 auto;
        padding-top: 20px;
        width: 1600px;
    }
}

// 小屏
@include mq($small) {
    .works {
        &-tabs {
            padding-bottom: 4px;
        }
        &-banner {
            width: 1200px;
        }
        &-body {
            width: 1200px;
        }
    }
}
</style>
